export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-policy/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-policy/List.vue'),
        name: 'attendance-policy',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-policy-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-policy/Add.vue'),
        name: 'attendance-policy-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-policy-allocation/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-policy-allocation/List.vue'),
        name: 'attendance-policy-allocation',
        meta: {
            requiresAuth: true
        }
    }
    ,
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-policy-allocation-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-policy-allocation/Add.vue'),
        name: 'attendance-policy-allocation-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/holidays/:pageId',
        component: () => import('@/views/page/company/hr-payroll/holidays/List.vue'),
        name: 'holidays',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/holidays-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/holidays/Add.vue'),
        name: 'holidays-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-policy/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-policy/List.vue'),
        name: 'leave-policy',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-policy-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-policy/Add.vue'),
        name: 'leave-policy-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-balance/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-balance/List.vue'),
        name: 'leave-balance',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-balance-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-balance/Add.vue'),
        name: 'leave-balance-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/manual-attendance-hr/:pageId',
        component: () => import('@/views/page/company/hr-payroll/manual-attendance/HrList.vue'),
        name: 'manual-attendance-hr',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-attendance/:pageId',
        component: () => import('@/views/page/company/hr-payroll/my-attendance/List.vue'),
        name: 'my-attendance',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-leave/:pageId',
        component: () => import('@/views/page/company/hr-payroll/my-leave/List.vue'),
        name: 'my-leave',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-report/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-report/List.vue'),
        name: 'attendance-report',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-log-summary/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-report/AttendanceLog.vue'),
        name: 'attendance-log-summary',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-approval/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-approval/List.vue'),
        name: 'attendance-approval',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/employee-register/:pageId',
        component: () => import('@/views/page/company/hr-payroll/employee-register/register/Index.vue'),
        name: 'employee-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/add-employee/:pageId',
        component: () => import('@/views/page/company/hr-payroll/employee-register/Add.vue'),
        name: 'add-employee',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-application-approval/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-application-approval/List.vue'),
        name: 'leave-application-approval',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-application/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-application/List.vue'),
        name: 'leave-application',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/leave-balance-summary/:pageId',
        component: () => import('@/views/page/company/hr-payroll/leave-balance-summary/List.vue'),
        name: 'leave-balance-summary',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-summary/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-summary/Summary.vue'),
        name: 'attendance-summary',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-monthly-report/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-summary/Report.vue'),
        name: 'attendance-monthly-report',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/employee-list/:pageId',
        component: () => import('@/views/page/company/hr-payroll/employee-register/List.vue'),
        name: 'employee-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/pay-head/:pageId',
        component: () => import('@/views/page/company/hr-payroll/pay-head/List.vue'),
        name: 'pay-head',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/pay-head-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/pay-head/Add.vue'),
        name: 'pay-head-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/salary-structures/:pageId',
        component: () => import('@/views/page/company/hr-payroll/salary-structures/List.vue'),
        name: 'salary-structures',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/salary-grade-scale/:pageId',
        component: () => import('@/views/page/company/hr-payroll/salary-grade-scale/List.vue'),
        name: 'salary-grade-scale',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payroll-process/:pageId',
        component: () => import('@/views/page/company/hr-payroll/payroll-process/List.vue'),
        name: 'payroll-process',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payroll-process/:pageId/view/:payrollMasterId',
        component: () => import('@/views/page/company/hr-payroll/payroll-process/Show.vue'),
        name: 'payroll-view',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payroll/:pageId/statement/:payrollStatementId',
        component: () => import('@/views/page/company/hr-payroll/payroll-process/Statement.vue'),
        name: 'payroll-statement',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/attendance-import/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-import/AttendanceImportList.vue'),
        name: 'attendance-import',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/upload-attendance/:pageId',
        component: () => import('@/views/page/company/hr-payroll/attendance-import/UploadAttendance.vue'),
        name: 'upload-attendance',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/job-requisition/:pageId',
        component: () => import('@/views/page/company/hr-payroll/job-requisition/List.vue'),
        name: 'job-requisition',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/job-requisition-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/job-requisition/Add.vue'),
        name: 'job-requisition-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/job-approval/:pageId',
        component: () => import('@/views/page/company/hr-payroll/job-requisition/JobApprovalList.vue'),
        name: 'job-approval',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/job-posting/:pageId',
        component: () => import('@/views/page/company/hr-payroll/job-requisition/JobPostingList.vue'),
        name: 'job-posting',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/job-application-manager/:pageId',
        component: () => import('@/views/page/company/hr-payroll/job-application-manager/List.vue'),
        name: 'job-application-manager',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/appointment/:pageId',
        component: () => import('@/views/page/company/hr-payroll/appointment/List.vue'),
        name: 'appointment',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/offer-letter-add/:pageId',
        component: () => import('@/views/page/company/hr-payroll/appointment/Add.vue'),
        name: 'offer-letter-add',
        meta: {
            requiresAuth: true
        }
    },
]